export default {
    name: 'OnboardingIndex',
    props: {
      title: {
        type: String,
        required: true,
      },
      submit_button_text: {
        type: String,
        default: "Submit", // Default button text
      },
      url_forgot_password: {
         type: String,
         default: "#" // Default value or however you're handling this
      },
      verification_running: {
        type: Boolean,
        default: false,
      },
      hide_submit_button: {
        type: Boolean,
        default: false
      },
      custom_submit_button: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        // Any component-specific data if needed
        username: "",
        password: ""
      };
    },
    computed: {
      show_default_submit_button() {
        return !this.hide_submit_button && !this.custom_submit_button;
      }
    },
    methods: {
      submitForm() {
        // Handle form submission logic here.  Access props and data.
        this.$emit('custom-submit', { username: this.username, password: this.password }); // Emit a 'submit' event
      }
    }
  };